import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import ShowItemBtn from '../../../../components/ShowItemBtn/ShowItemBtn';

import Modal from './Modal';

class Colores extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    show: false,
                    private: true,
                },
                {
                    Header: "Codigo",
                    id: "Codigo",
                    accessor: "Codigo",
                    show: true,
                    width: 150,
                },
                {
                    Header: "Nombre En SIGE",
                    id: "NombreEnSIGE",
                    accessor: d => d.NombreEnSIGE,
                    show: true,
                },
                {
                    Header: "Nombre en Web",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
                {
                    Header: "Visible",
                    id: "Show",
                    accessor: d => d.Show ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : ""}>
                            <option value="">TODOS</option>
                            <option value={"True"}>SI</option>
                            <option value={"False"}>NO</option>
                        </select>
                    ),
                    width: 100,
                    className: "text-center",
                },
                {
                    Header: "De Baja",
                    id: "DeBaja",
                    accessor: d => d.DeBaja ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            onChange={event => onChange(event.target.value)}
                            style={{ width: "100%" }}
                            value={filter ? filter.value : ""}>
                            <option value="">TODOS</option>
                            <option value={"True"}>SI</option>
                            <option value={"False"}>NO</option>
                        </select>
                    ),
                    width: 100,
                    className: "text-center",
                },
            ]
        };
    }

    render() {
        const { modernTheme } = this.props;
        const propsShowItemBtn = {
            label: 'Color',
            labelMany: 'Colores',
            submitUrl: api.gestion.articulos.coloresMostrarOcultar,
            femaleLabel: true
        }
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'ecommerce_articulos_articulos_edit',
                    },
                    {
                        detail: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'ecommerce_articulos_articulos_edit',
                    },
                    {
                        permission: "ecommerce_articulos_articulos_edit",
                        customComponent: true,
                        multiSelect: true,
                        component: (props) => (<ShowItemBtn {...props} {...propsShowItemBtn} action="MOSTRAR" />),
                    },
                    {
                        permission: "ecommerce_articulos_articulos_edit",
                        customComponent: true,
                        multiSelect: true,
                        component: (props) => (<ShowItemBtn {...props} {...propsShowItemBtn} action="OCULTAR" />),
                    },
                ]}
                outerFilter={[{ id: "DeBaja", lookup: "exact", value: "False" }]}
                apiUrl={api.gestion.articulos.colores}
                columns={this.state.columns}
                title={"Colores"}
            />
        );
    }
}

export default Colores;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Colores/Colores.js